import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to track page views with Google Analytics
 * @returns {void}
 */
export const useGoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    try {
      if (window.gtag) {
        window.gtag('config', 'G-5ZBLCZCR8Q', {
          page_path: location.pathname + location.search,
          page_title: document.title,
        });
      }
    } catch (error) {
      console.error('Error tracking page view:', error);
    }
  }, [location]);
}; 